/**
 * Core Border Radius Tokens — Tier 1
 *
 * Raw radius scale. Values are in pixels.
 * JS key maps to Figma token: borderRadius.md → border-radius-md.
 *
 * Component usage: import borderRadius from tokens directly — borderRadius.sm, borderRadius.xl, etc.
 * theme.shape.borderRadius (= md = 8px) is the MUI base scalar for internal MUI use only.
 *
 * Rules:
 * - Tier 2 semantic tokens reference these keys; never raw values
 */

export const borderRadius = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 20,
  full: 100,
} as const;

export type BorderRadius = typeof borderRadius;
export type BorderRadiusToken = keyof BorderRadius;
